import { ActivatedRoute, Router } from "@angular/router";
import { ChangeDetectorRef, Component, ElementRef, OnInit, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { OnlineEvaluationTermsComponent } from "./online-evaluation-terms/online-evaluation-terms.component";
import { EvalDealerPersonalizationConfig, EvalDealerPersonalizationConfigUtils } from "@app/views/public/eval-dealer-personalization-model";
import { CreateOnlineEvaluationRequest } from "@app/views/public/online-evaluation/online-eval.model";

@Component({
  selector: "app-online-evaluation-layout",
  templateUrl: "./online-evaluation-layout.component.html",
  styleUrls: ["./online-evaluation-layout.component.scss"],
})
export class OnlineEvaluationLayoutComponent implements OnInit {

  private hideHeader = false;
  currentYear: number;
  showTermsConditionsModal: boolean;
  createReq: CreateOnlineEvaluationRequest;
  sellerDetails: EvalDealerPersonalizationConfig;

  constructor(private route: ActivatedRoute, private router: Router, private cd: ChangeDetectorRef, private dialog: MatDialog, private elRef: ElementRef) {
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    const valor = getComputedStyle(this.elRef.nativeElement).getPropertyValue('--layout-bg-color').trim();

  }

  ngAfterViewInit() {
    const valor = getComputedStyle(this.elRef.nativeElement).getPropertyValue('--layout-bg-color').trim();

  }

  hasUrl(url: string, urls: string[]) {

    return urls.find((u) => url.indexOf(u) >= 0);
  }

  isHideHeader(): boolean {
    return this.hideHeader;
  }

  passSellerDetails(sellerDetails: EvalDealerPersonalizationConfig) {
    this.sellerDetails = sellerDetails;
  }

  setHideHeader(hideHeader: boolean): void {
    this.hideHeader = hideHeader;
    this.cd.detectChanges();
  }

  openTermsConditionsModal(): void {
    this.dialog
      .open(OnlineEvaluationTermsComponent, {
        width: '480px',
        hasBackdrop: true,
      })
      .afterClosed()
      .subscribe(() => {

      });
  }

  setBgColor(color: string) {
    if (color) {
      this.elRef.nativeElement.style.setProperty( '--layout-bg-color', color);
    }
  }
}
